import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import { closeDeleteUserModal } from '../../actions/modalActions';
import { deleteUser } from '../../actions/siteadmin/users';
import messages from '../../locale/jsonMessages';
import CustomConfirmModal from '../Common/CustomConfirmModal/CustomConfirmModal';


class DeleteUserModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false
        };
    }

    handleClick = async (userId) => {
        const { deleteUser } = this.props;
        this.setState({ isLoading: true });
        await deleteUser(userId);
        this.setState({ isLoading: false });
    }
    render() {
        const { formatMessage } = this.props.intl;
        const { openDeleteUserModal, closeDeleteUserModal, userId } = this.props;
        const { isLoading } = this.state;

        return (
            <CustomConfirmModal
                showModel={openDeleteUserModal}
                title={formatMessage(messages.deleteAccount)}
                bodyText={formatMessage(messages.areYouSureDeleteAccount)}
                closeModal={closeDeleteUserModal}
                load={isLoading}
                popupButtonLeftFunction={closeDeleteUserModal}
                popupButtonLeftName={formatMessage(messages.cancel)}
                loaderConfirmActionFunction={() => { this.handleClick(userId) }}
                loaderActionBtnText={formatMessage(messages.proceed)}
            />
        )
    }
}

const mapState = (state) => ({
    openDeleteUserModal: state?.modalStatus?.deleteUserModal,
    userId: state?.account?.data?.userId
});

const mapDispatch = {
    closeDeleteUserModal,
    deleteUser
};

export default injectIntl(connect(mapState, mapDispatch)(DeleteUserModal));
